import { REVIEW_LINKS } from "../data/nap";

export const GuestReviews = ({ testPrefix = "guests" }) => (
  <div data-testid={`${testPrefix}-reviews-block`}>
    <p className="text-base text-neutral-800 max-w-xl">Read what guests say about our Indian and Punjabi cooking, in their own words.</p>
    <div className="mt-4 flex flex-wrap gap-3">
      <a href={REVIEW_LINKS.google} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-reviews-google`}
        className="inline-flex items-center min-h-[44px] px-6 py-2.5 rounded-full bg-[#1a1410] text-white text-sm font-bold hover:bg-[#db594b] transition-colors">
        Reviews on Google
      </a>
      <a href={REVIEW_LINKS.yelp} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-reviews-yelp`}
        className="inline-flex items-center min-h-[44px] px-6 py-2.5 rounded-full border-2 border-[#1a1410] text-sm font-bold hover:border-[#db594b] hover:text-[#db594b] transition-colors">
        Reviews on Yelp
      </a>
    </div>
  </div>
);

export default GuestReviews;
